import modal from './modal.json';
import eventsTypes from './eventsTypes.json';
import filterSelect from './filterSelect.json';
import reportExportModal from './reportExportModal.json';

export default {
    modal,
    eventsTypes,
    filterSelect,
    reportExportModal,
};
